/**
 * SplashScreen - Controls the HTML splash screen visibility
 *
 * The actual splash screen is in index.html for instant display
 * (including the inline CSS-only dot-matrix spinner). This component
 * just hides it once React signals the app is ready.
 */

import { useEffect } from 'react';

type SplashScreenProps = {
  isReady: boolean;
};

export function SplashScreen({ isReady }: SplashScreenProps) {
  useEffect(() => {
    const splash = document.getElementById('splash-screen');
    if (!splash) return;

    if (isReady) {
      splash.classList.add('hidden');
      const timer = setTimeout(() => {
        splash.remove();
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [isReady]);

  return null;
}
